"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NiftipayVerificationStatus = void 0;
var NiftipayVerificationStatus;
(function (NiftipayVerificationStatus) {
    NiftipayVerificationStatus["NOT_STARTED"] = "not_started";
    NiftipayVerificationStatus["PENDING"] = "pending";
    NiftipayVerificationStatus["SUBMITTED"] = "submitted";
    NiftipayVerificationStatus["APPROVED"] = "approved";
    NiftipayVerificationStatus["REJECTED"] = "rejected";
})(NiftipayVerificationStatus = exports.NiftipayVerificationStatus || (exports.NiftipayVerificationStatus = {}));
